import usegetdata from '../../Hooks/useGetData';
import {
  Get_Error,
  GetAllMeetingCommentsByUser_Type,
  GetAllMeetingCommentsForoneuser_Type,
  GetAllMettingsheetForAdmin_type,
} from '../Types';

export const Get_AllComments_AddedBy_User_Action = (leadid, userid) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Meetingcomments/lead/${leadid}/user/${userid}`);

    dispatch({
      type: GetAllMeetingCommentsForoneuser_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_AllComments_For_Sheet_By_User_Action = (quarystring) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Meetingcomments/user/${quarystring}`);

    dispatch({
      type: GetAllMeetingCommentsByUser_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_AllComments_For_Sheet_For_Admin_Action = (quarystring) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Meetingcomments/${quarystring}`);

    dispatch({
      type: GetAllMettingsheetForAdmin_type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
